import axios, { AxiosResponse, InternalAxiosRequestConfig } from 'axios';
import { getToken, removeToken } from 'utils/LocalStorageUtils';
import { HttpStatus } from 'config/http-status.config';
import UrlConfig from 'config/url.config';
import { AppConfig } from '../config/app.config';

const BaseAxios = axios.create({
  baseURL: AppConfig.baseUrl,
  timeout:  AppConfig.timeOut
});

BaseAxios.defaults.withCredentials =true;

BaseAxios.interceptors.request.use(function (request: InternalAxiosRequestConfig) {
  const token = getToken();
  if(token != null && request.headers) {
    request.headers['Authorization'] = `Bearer ${token}`
  }
  return request;
}, function (error) {
  !AppConfig.production && console.error(error);
})

BaseAxios.interceptors.response.use(function (response: AxiosResponse) {
  !AppConfig.production && console.log(response.data);
  return response.data;
}, function (error) {
  if (error.response?.status === HttpStatus.UNAUTHORIZED) {
    removeToken();
    if (!window.location.pathname.includes(UrlConfig.LOGIN)) {
      window.location.href = UrlConfig.LOGIN;
    }
  }
  return Promise.reject(error);
})

export default BaseAxios;

